import React from "react";

import store from "../../redux/store";
import { tTooltipSeat } from "../../assets/libs/i18n/translator";
import { SelectionTypeEnum } from "../../enums";

export const TooltipSeatSelector = (target: any, info: any, handleSelectObject: any, handleClose?: any) => {
    const {
        properties: { selection },
    } = store.getState();
    const isTouch = !!handleSelectObject;
    const getInfoSpan = () => {
        if (target.available) {
            if (target.status == "Free") {
                const selectedZoneLength: {
                    key: string;
                    seats: Array<string>;
                } = selection.filter((zone: any) => {
                    return zone.key == target.category.key;
                })[0];
                if (
                    selectedZoneLength.seats.length ==
                    window.redseats.maximumsSeatsSelected
                )
                    return (
                        <div className="cant_choose">
                            <span className="icon-close"></span>{" "}
                            {tTooltipSeat("you-cant-choose-more-places")}{" "}
                        </div>
                    );
                if (handleSelectObject)
                    return (
                        <div className="box_btns_modal">
                            <button className="btn_neutro for_select" onClick={handleSelectObject}>
                                <span className="icon-checkmark"></span>{" "}
                                {tTooltipSeat("select")}
                            </button>
                            {isTouch && handleClose && (
                                <button className="btn_neutro for_close" onClick={handleClose}>
                                    Cerrar
                                </button>
                            )}
                        </div>
                    );
                return (
                    <div className="box_btns_modal">
                        {isTouch && handleClose && (
                            <button className="btn_neutro for_close w-100" onClick={handleClose}>
                                Cerrar
                            </button>
                        )}
                    </div>
                );
            } else if (target.isHoldByMe) {
                if (handleSelectObject)
                    return (
                        <div className="box_btns_modal">
                            <button className="btn_neutro" onClick={handleSelectObject}>
                                <span className="icon-close"></span>{" "}
                                {tTooltipSeat("deselect")}
                            </button>
                            {isTouch && handleClose && (
                                <button className="btn_neutro for_close" onClick={handleClose}>
                                    Cerrar
                                </button>
                            )}
                        </div>
                    );
                return (
                    <div className="box_btns_modal">
                        <p>{tTooltipSeat("selected")}</p>
                        {isTouch && handleClose && (
                            <button className="btn_neutro for_close" onClick={handleClose}>
                                Cerrar
                            </button>
                        )}
                    </div>
                );
            }
        }
        return (
            <div className="box_btns_modal">
                <div style={{ width: '100%', marginBottom: '10px' }}>{tTooltipSeat("not-available")}</div>
                {isTouch && handleClose && (
                    <button className="btn_neutro for_close w-100" onClick={handleClose}>
                        Cerrar
                    </button>
                )}
            </div>
        );
    };

    return (
        <div
            className={`wrapper_in_tooltip_seats ${isTouch ? 'is_mobile_modal' : ''}`}
            style={{ borderLeft: `4px solid ${target.category?.color ?? ""}` }}
        >
            {target.category && (
                <div
                    className="box_name_category"
                    style={{ color: target.category.color }}
                >
                    <p> {target.category.name}</p>
                </div>
            )}
            {target.restrictedView && (
                <div
                    className="box_name_icons"
                    style={{ borderColor: target.category.color }}
                >
                    <p style={{ color: target.category.color }}>
                        <span className="icon-restricted-view"></span>
                        <span>{tTooltipSeat("restrictedView")}</span>
                    </p>
                </div>
            )}
            {target.accesible && (
                <div
                    className="box_name_icons"
                    style={{ borderColor: target.category.color }}
                >
                    <p style={{ color: target.category.color }}>
                        <span className="icon-accesible"></span>
                        <span>{tTooltipSeat("accessible")}</span>
                    </p>
                </div>
            )}
            {target.companion && (
                <div
                    className="box_name_icons"
                    style={{ borderColor: target.category.color }}
                >
                    <p style={{ color: target.category.color }}>
                        <span className="icon-companion"></span>
                        <span>{tTooltipSeat("companion")}</span>
                    </p>
                </div>
            )}

            <div className="box_details_seats">
                <p>
                    <span>
                        {tTooltipSeat("section")}:{" "}
                        <strong>{target.sectionLabel || "?"}</strong>{" "}
                    </span>
                    &nbsp;
                </p>
                <p>
                    <span>
                        {target.rowLabel ? tTooltipSeat("row") : tTooltipSeat("table")}:{" "}
                        <strong>{(target.rowLabel ? target.rowLabel : target.tableLabel) || "?"}</strong>
                    </span>
                    &nbsp; &nbsp;
                    {(target.selectionType === SelectionTypeEnum.none || target.selectionType === SelectionTypeEnum.bySeat) && <span>
                        {tTooltipSeat("seat")}: <strong>{target.label || "?"}</strong>
                    </span>}

                </p>
            </div>

            <div className="box_info_seats">
                <span
                    dangerouslySetInnerHTML={{ __html: info }}
                />
            </div>

            <div className="box_handle_mnsj">{getInfoSpan()}</div>
        </div>
    );
};